import type { Distance, Pixel, SpatialRectangle } from "@pdfking/math"
import { Min, Round } from "@pdfking/math"
import { CM, Convert, MM } from "@pdfking/quantity"
import { DISTANCE } from "@pdfking/quantity/constants"
import type { ColorID } from "@pdfking/renderer-api"
import { HorizontalAlign, VerticalAlign } from "@pdfking/renderer-api"

import type { ShapeSequence } from "#internal"

import { CreateText } from "../../../shapes/CreateText"

const DYNAMIC_OFFSET = MM(5)

const help_texts = [
  ["crossmark", "Le guide non vengono stampate: lasciale pure per allineare i contenuti"],
  ["security", "Margine di sicurezza"],
  ["bleed", "Area stampabile"],
  ["cut", "Taglio"],
  ["fold", "Piega"],
] as const

/** The legend of the help colours. Each page's bleed box is the grow's to
 * draw (`DrawGrowHelp`), cut to the room the page has. */
export function* GetShapesForUserHelp(canvas: SpatialRectangle<Distance>): ShapeSequence {
  const left = (DYNAMIC_OFFSET * 2) as Distance
  const right = Min(canvas.width - DYNAMIC_OFFSET * 2, CM(10)) as Distance
  const width_in_cm = Convert(canvas.width, DISTANCE, DISTANCE.standard_unit, "cm")
  const row_height = Convert(width_in_cm, DISTANCE, "px", DISTANCE.standard_unit) as Distance
  const rendered_row_height = Round(row_height) as Distance

  for (const [i, [color, text]] of help_texts.entries()) {
    yield CreateText(
      {
        x: (canvas.x + left) as Distance,
        y: Round(canvas.y + DYNAMIC_OFFSET * 2 + i * row_height) as Distance,
        width: (right - left) as Distance,
        height: rendered_row_height,
      },
      text,
      {
        vertical_align: VerticalAlign.TOP,
        horizontal_align: HorizontalAlign.LEFT,
        font_size: Round(canvas.width / CM(2)) as Pixel,
        text_color: color as ColorID,
      }
    )
  }
}
